import React from 'react';

import { SearchBar } from '../../components/search/SearchBar.js';
import { SectionBar } from './SectionBar.js';
import { TopTags } from './TopTags.js';

interface EmptySearchProps {
  isMobile: boolean;
  activeSection: string;
  setActiveSection: (text: string) => void;
}

export const EmptySearch: React.FC<EmptySearchProps> = ({
  isMobile,
  activeSection,
  setActiveSection,
}) => {
  const handleGoBack = () => {
    window.history.go(-1);

    return false;
  };

  return (
    <div className="empty-search-container">
      <h1 className="empty-search-title">Søk i:</h1>
      <SectionBar
        activeSection={activeSection}
        setActiveSection={setActiveSection}
      />
      <SearchBar
        isMobile={isMobile}
        activeSection={activeSection}
        setActiveSection={setActiveSection}
      />
      <TopTags section={activeSection} />
      <button className="stop-search" onClick={handleGoBack}>
        Avbryt søket
      </button>
    </div>
  );
};
